module.exports = __webpack_public_path__ + "img/43.c8611c07.jpg";